export const adjectives = [
    "Struggling",
    "Digesting",
    "Fishing",
    "Flushing",
    "Broadcasting",
    "Cutting",
    "Dozing",
    "Winking",
    "Judging",
    "Drumming",
    "Wheezing",
    "Hopping",
    "Twitching",
    "Pushing",
    "Bombing",
    "Stealing",
    "Glistening",
    "Exploding",
    "Congesting",
    "Consulting",
];